export const CORRESPONDENCE_DETAILS = 'corrsepondence-details';
export const BILLING_DETAILS = 'billing-details';

export const CONTACT_DETAILS = [
    {
        sectionID: CORRESPONDENCE_DETAILS,
        sectionName: 'Correspondence Details',
        fieldList: [
            {
                id: 'contactPerson',
                label: 'Contact Person',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'mobileNo',
                label: 'Mobile No',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'telNumber',
                label: 'Office No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'text',
                rule: { required: true, charLength: 32 },
                isNextEmpty: true
            },
            {
                id: 'Postal',
                label: 'Postal Code',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: { required: true, charLength: 32 }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: { charLength: 66 }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: { charLength: 3 }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: { charLength: 5 }
            }
        ]
    },
    {
        sectionID: BILLING_DETAILS,
        sectionName: 'Billing Details',
        fieldList: [
            {
                id: 'contactPerson',
                label: 'Contact Person',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'mobileNo',
                label: 'Mobile No',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'telNumber',
                label: 'Office No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'text',
                rule: { required: true, charLength: 32 },
                isNextEmpty: true
            },
            {
                id: 'Postal',
                label: 'Postal Code',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: { required: true, charLength: 32 }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: { charLength: 66 }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: { charLength: 3 }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: { charLength: 5 }
            }
        ]
    }
];
